(function () {
  var DRAFT_KEY = 'anzo_reseller_application_draft_v1';
  var DRAFT_META_KEY = 'anzo_reseller_application_draft_meta_v1';

  var STEPS = [
    {
      id: 'company',
      title: 'Company Information',
      description: 'Tell us about your business and the credit terms you are requesting.',
      fields: [
        { name: 'Text1', label: 'Company Name', required: true },
        { name: 'Text3', label: 'DBA' },
        { name: 'Text4', label: 'Address', required: true, full: true },
        { name: 'Text5', label: 'City', required: true },
        { name: 'Text6', label: 'State', required: true },
        { name: 'Text7', label: 'Zip', required: true },
        { name: 'Text8', label: 'Phone', type: 'tel', required: true },
        { name: 'Text9', label: 'Fax', type: 'tel' },
        {
          name: 'entity_type',
          label: 'Entity Type',
          type: 'radio',
          required: true,
          full: true,
          // PDF marker fields on the Entity row (verified visually):
          // Text10 = after "Entity" label, Text11=Sole, Text12=Partnership,
          // Text13=Corporation, Text14=Other (specify).
          options: [
            { value: 'sole', label: 'Sole Proprietorship', markField: 'Text11' },
            { value: 'partnership', label: 'Partnership', markField: 'Text12' },
            { value: 'corporation', label: 'Corporation', markField: 'Text13' },
            { value: 'other', label: 'Other', markField: 'Text14' }
          ]
        },
        { name: 'Text14', label: 'If Other, please specify', full: true },
        { name: 'Text15', label: 'Federal Tax ID #', required: true },
        { name: 'Text16', label: 'State Resale #', required: true },
        { name: 'Text17', label: 'D & B #' },
        { name: 'Text18', label: 'Type of Business', required: true },
        { name: 'Text19', label: 'Year Established', required: true },
        { name: 'Text20', label: 'At Present Location Since' },
        { name: 'Text21', label: 'Financial Contact in Firm', required: true },
        { name: 'Text22', label: 'Financial Contact Phone', type: 'tel' },
        { name: 'Text23', label: 'Ext' },
        { name: 'Text24', label: 'Name of Purchaser in Firm', required: true },
        { name: 'Text25', label: 'Purchaser Email', type: 'email', required: true },
        {
          name: 'TermCredit Limit Requested',
          label: 'Term / Credit Limit Requested',
          required: true,
          full: true,
          note:
            'I/We hereby apply to Anzo USA (hereinafter “Vendor”) for credit and/or an increase, update or reconfirmation of our existing account. The undersigned gives and grants Vendor permission to verify all information stated herein. I/We hereby agree that all credit granted and/or extended shall be repaid in a timely fashion.'
        }
      ]
    },
    {
      id: 'principals',
      title: 'Principals of Company',
      description: 'Owner / officer information for the applying company.',
      fields: [
        { name: 'Text26', label: 'Name' },
        { name: 'Text27', label: 'Title' },
        { name: 'Text28', label: 'Home Phone', type: 'tel' },
        { name: 'Text29', label: 'Address', full: true },
        { name: 'Text30', label: 'City' },
        { name: 'Text31', label: 'State' },
        { name: 'Text32', label: 'Zip' },
        { name: 'Text33', label: 'Social Security #' },
        { name: 'Text34', label: 'Email', type: 'email' }
      ]
    },
    {
      id: 'banks',
      title: 'Bank References',
      description: 'Required for Net Terms approval. You may complete one or both banks.',
      groups: [
        {
          title: 'Bank Reference 1',
          fields: [
            { name: 'Text35', label: 'Bank Name' },
            { name: 'Text36', label: 'Contact Person' },
            { name: 'Text37', label: 'Address', full: true },
            { name: 'Text38', label: 'City' },
            { name: 'Text39', label: 'State' },
            { name: 'Text40', label: 'Zip' },
            { name: 'Text41', label: 'Phone', type: 'tel' },
            { name: 'Text42', label: 'Fax', type: 'tel' },
            { name: 'Text43', label: 'Line of Credit' },
            { name: 'Text44', label: 'Checking Acct #' },
            { name: 'Text45', label: 'Savings Acct #' },
            { name: 'Text46', label: 'Loan Acct #' }
          ]
        },
        {
          title: 'Bank Reference 2',
          fields: [
            { name: 'Text47', label: 'Bank Name' },
            { name: 'Text48', label: 'Contact Person' },
            { name: 'Text49', label: 'Address', full: true },
            { name: 'Text50', label: 'City' },
            { name: 'Text51', label: 'State' },
            { name: 'Text52', label: 'Zip' },
            { name: 'Text53', label: 'Phone', type: 'tel' },
            { name: 'Text54', label: 'Fax', type: 'tel' },
            { name: 'Text55', label: 'Line of Credit' },
            { name: 'Text56', label: 'Checking Acct #' },
            { name: 'Text57', label: 'Savings Acct #' },
            { name: 'Text58', label: 'Loan Acct #' }
          ]
        }
      ]
    },
    {
      id: 'trade',
      title: 'Trade References',
      description: 'Please provide up to three trade references.',
      groups: [
        {
          title: 'Trade Reference 1',
          fields: [
            { name: 'Text59', label: 'Company Name' },
            { name: 'Text60', label: 'DBA' },
            { name: 'Text61', label: 'Contact Person' },
            { name: 'Text62', label: 'Address', full: true },
            { name: 'Text63', label: 'City' },
            { name: 'Text64', label: 'State' },
            { name: 'Text65', label: 'Zip' },
            { name: 'Text66', label: 'Phone', type: 'tel' },
            { name: 'Text67', label: 'Fax', type: 'tel' },
            { name: 'Text68', label: 'Email', type: 'email' }
          ]
        },
        {
          title: 'Trade Reference 2',
          fields: [
            { name: 'Text69', label: 'Company Name' },
            { name: 'Text70', label: 'DBA' },
            { name: 'Text71', label: 'Contact Person' },
            { name: 'Text72', label: 'Address', full: true },
            { name: 'Text73', label: 'City' },
            { name: 'Text74', label: 'State' },
            { name: 'Text75', label: 'Zip' },
            { name: 'Text77', label: 'Phone', type: 'tel' },
            { name: 'Text78', label: 'Fax', type: 'tel' },
            { name: 'Text79', label: 'Email', type: 'email' }
          ]
        },
        {
          title: 'Trade Reference 3',
          fields: [
            { name: 'Text80', label: 'Company Name' },
            { name: 'Text81', label: 'DBA' },
            { name: 'Text82', label: 'Contact Person' },
            { name: 'Text83', label: 'Address', full: true },
            { name: 'Text84', label: 'City' },
            { name: 'Text85', label: 'State' },
            { name: 'Text86', label: 'Zip' },
            { name: 'Text87', label: 'Phone', type: 'tel' },
            { name: 'Text88', label: 'Fax', type: 'tel' },
            { name: 'Text89', label: 'Email', type: 'email' }
          ]
        },
        {
          title: 'Authorization Signature',
          fields: [
            { name: 'Text90', label: 'Printed Name', required: true },
            { name: 'Text93', label: 'Title', required: true },
            { name: 'Text94', label: 'Date', type: 'date', required: true }
          ]
        }
      ]
    },
    {
      id: 'guarantee',
      title: 'Personal Guarantee & Tax Certificate',
      description: 'Continuing personal guarantee and multi-jurisdiction tax certificate details.',
      groups: [
        {
          title: 'Continuing Personal Guarantee',
          note:
            'For goods and valuable consideration, including the extension of credit to the company or companies listed on this application (“customer”) from which I will benefit, do hereby personally guarantee and promise to pay on demand any obligation of customer to Anzo USA without regard for any claim of setoff, counterclaim or defense. I hereby waive notice of sales to customer, and of the terms thereof, and of non-payment or other default or dispute with Customer. I hereby waive any right to a jury trial and consent to all renewals and modifications of terms of sale or credit. This is a continuing and irrevocable guarantee and I hereby subordinate any indebtedness of Customer to me to that of Customer to Anzo USA.',
          fields: [
            { name: 'Text95', label: 'Print Name' },
            { name: 'Text96', label: 'Title' },
            { name: 'Text97', label: 'Date', type: 'date' },
            { name: 'Text98', label: 'Driver License #' },
            { name: 'Text99', label: 'State' },
            { name: 'Text100', label: 'Social Security #' },
            { name: 'Text101', label: 'Home Address / Phone', full: true }
          ]
        },
        {
          title: 'Security Agreement',
          note:
            '1. The undersigned agrees that Anzo USA (“Seller”), will maintain a security interest in all goods that Seller sells and delivers to the undersigned (“Buyer”), and all proceeds thereof (“Collateral”). Buyer will refrain from moving the Collateral from its present location and will advise Seller on demand as to the location of all collateral in its possession. Buyer will execute on demand a UCC-1 or similar financing statement to perfect Seller’s rights in the Collateral. If Buyer fails to execute such a document, Seller may do so and sign Buyer’s name. Buyer irrevocably appoints Seller as its attorney-in-fact to place said signature on the document and record it with the appropriate authority.\n\n2. If Buyer fails to pay as agreed, or otherwise defaults, Seller may possess the Collateral, and may enter onto private property and any structure to do so. Buyer is obligated to assemble the Collateral. If the Collateral is repossessed, Seller may exercise all rights of the Uniform Commercial Code or the similar statutes in any state where the Collateral is taken. Upon repossession, the Seller may sell without notice and at private sale, to the greatest extent allowed by law, and may sell in any commercially reasonable manner.\n\n3. Seller has all rights under law. All rights are cumulative. Buyer will reimburse the Seller for any loss, damage, cost or expense, including without limitation reasonable attorney’s fees and legal expenses, in connection with the exercise of any right or remedy pursuant to this Agreement. Service of process shall be effective if mailed to the applicable party at the address set forth herein.\n\n4. Until payment is made in full of all obligations owing to Seller, Buyer will not assign or pledge the Collateral and will maintain the Collateral free and clear of all liens, claims, taxes and encumbrances, or any other third party interest (collectively, “Encumbrances”). Any such assignment, pledge or Encumbrance shall be void.\n\n5. The terms and conditions of this Agreement apply to all sales made between the parties. The price, term of payment, delivery information, and all matters including warranty information placed on the front or reverse of the invoice delivered by Seller in connection with the sale shall be the terms of sale. If no payment terms are specified, then the terms of payment are C.O.D. Time is of the essence. The terms of Seller’s invoice and this Agreement shall supersede any contrary terms in the Buyer’s Purchase Order. I/We agree to the above and state that all information in the credit application is true, and Seller may check all credit sources, and the credit of any guarantors. If any information is false, then Seller can declare all sums due and owing and exercise any right to the Collateral.',
          fields: [
            { name: 'Text102', label: 'Print Name' },
            { name: 'Text103', label: 'Company' },
            { name: 'Text104', label: 'Title' },
            { name: 'Text106', label: 'Date', type: 'date' },
            { name: 'Text107', label: 'Company Address', full: true }
          ]
        },
        {
          title: 'Sales & Use Tax Certificate',
          fields: [
            { name: 'Text108', label: 'I certify that', full: true },
            { name: 'Text109', label: 'Name of Firm (Buyer)', full: true },
            { name: 'Text110', label: 'Street Address', full: true },
            { name: 'Text111', label: 'City / State / Zip', full: true },
            { name: 'Text112', label: 'Phone', type: 'tel' },
            {
              name: 'business_type',
              label: 'is engaged as a registered',
              type: 'checks',
              full: true,
              options: [
                { name: 'Check Box 1', label: 'Wholesaler' },
                { name: 'Check Box 2', label: 'Retailer' },
                { name: 'Check Box 3', label: 'Manufacturer' },
                { name: 'Check Box 4', label: 'Other' }
              ]
            },
            { name: 'Text114', label: 'Other (Specify)' },
            { name: 'Text115', label: 'State Reseller Certificate Number', full: true },
            {
              name: 'Text116',
              label: 'Registered State',
              note:
                'And is registered with the state of (above) and cities within your firm would deliver purchases to us and that any such purchases are for wholesale, resale, ingredients or components of a new product to be resold, leased or rented in the normal course of business. We are in the business of wholesaling, retailing, manufacturing or leasing (renting) the following:'
            },
            { name: 'Text117', label: 'Description of Business', full: true, type: 'textarea' },
            {
              name: 'products_purchased_note',
              type: 'static',
              full: true,
              text: 'General description of products to be purchased from the seller: Automotive lighting, accessories or related items.'
            },
            {
              name: 'reseller_permit',
              type: 'file',
              full: true,
              required: true,
              accept: 'image/jpeg,image/png,image/webp,image/gif,application/pdf',
              key: 'reseller_permit',
              label: 'Please attach a copy of your State Reseller Permit'
            },
            {
              name: 'tax_cert_statement',
              type: 'static',
              full: true,
              text:
                'I further certify that if any property so purchased tax-free is used or consumed by the firm as to make it subject to a Sales or Use Tax, we will pay the tax due directly to the proper taxing authority when state law so provides or inform the seller for added tax billing. This certificate shall be part of each order that we may hereafter give to you, unless otherwise specified, and shall be valid until canceled by us in writing or revoked by the city or state. Under penalties of perjury, I swear or affirm that the information on this form is true and correct as to every material matter.'
            },
            { name: 'Text120', label: 'Print Name (Owner, Partner, or Corporate Officer)' },
            { name: 'Text121', label: 'Title' },
            { name: 'Text122', label: 'Date', type: 'date' }
          ]
        }
      ]
    },
    {
      id: 'bank-auth',
      title: 'Bank Credit Authorization',
      description: 'Authorize your bank to release credit information to Anzo USA.',
      fields: [
        { name: 'Text125', label: 'Bank Name', full: true },
        { name: 'Text126', label: 'Address' },
        { name: 'Text127', label: 'City' },
        { name: 'Text128', label: 'State' },
        { name: 'Text129', label: 'Zip' },
        { name: 'Text130', label: 'Phone', type: 'tel' },
        { name: 'Text131', label: 'Fax', type: 'tel' },
        { name: 'Text132', label: 'Our Company Name', full: true },
        { name: 'Text133', label: 'Checking Account Number' },
        { name: 'Text134', label: 'Savings Account Number' },
        { name: 'Text135', label: 'Loan Account Number' },
        { name: 'Text136', label: 'Line of Credit' },
        { name: 'Text137', label: 'Credit Limit' },
        { name: 'Text142', label: 'Owner / Officer Print Name', required: true },
        { name: 'Text143', label: 'Title' },
        { name: 'Text145', label: 'Date', type: 'date', required: true },
        { name: 'Text146', label: 'Completed By' },
        { name: 'Text147', label: 'Completed Date', type: 'date' }
      ]
    },
    {
      id: 'cc-prepaid',
      title: 'Credit Card Authorization (Prepaid)',
      description: 'Optional — complete if you are a prepaid customer.',
      fields: [
        { name: 'Text167', label: 'Company Name', full: true },
        { name: 'Text168', label: 'Address', full: true },
        { name: 'Text169', label: 'City' },
        { name: 'Text170', label: 'State' },
        { name: 'Text171', label: 'Zip' },
        { name: 'Text172', label: 'Fax #', type: 'tel' },
        { name: 'Text173', label: 'Telephone #', type: 'tel' },
        { name: 'Text174', label: "Cardholder's Name", full: true },
        { name: 'Text175', label: 'Driver License #' },
        { name: 'Text176', label: 'DL State' },
        { name: 'Text177', label: 'Credit Card Account #', full: true },
        { name: 'Text178', label: 'CVV #' },
        {
          name: 'prepaid_card_type',
          label: 'Card Type',
          type: 'checks',
          full: true,
          options: [
            { name: 'Check Box 5', label: 'Visa' },
            { name: 'Check Box 6', label: 'MasterCard' },
            { name: 'Check Box 7', label: 'Discover' }
          ]
        },
        { name: 'Text180', label: 'Expiration Date' },
        { name: 'Text181', label: "Cardholder's Phone #", type: 'tel', full: true },
        { name: 'Text182', label: 'Credit Card Billing Address', full: true },
        { name: 'Text183', label: 'Billing City' },
        { name: 'Text184', label: 'Billing State' },
        { name: 'Text185', label: 'Billing Zip', full: true },
        { name: 'Text187', label: 'Signature Date', type: 'date' }
      ]
    },
    {
      id: 'cc-term',
      title: 'Credit Card Authorization (Term)',
      description: 'Optional — complete if you are a Net Terms customer authorizing card charges.',
      fields: [
        { name: 'Text188', label: 'Customer #' },
        { name: 'Text189', label: 'Date', type: 'date' },
        { name: 'Text191', label: "Cardholder's Name", full: true },
        { name: 'Text192', label: 'Company Name' },
        { name: 'Text193', label: 'Title of Cardholder' },
        { name: 'Text194', label: 'Driver License #' },
        { name: 'Text195', label: 'DL State', full: true },
        { name: 'Text196', label: 'Credit Card Account #', full: true },
        { name: 'Text197', label: 'CVV #' },
        { name: 'Text198', label: 'Expiration Date' },
        { name: 'Text199', label: 'Credit Card Bank Phone #', type: 'tel', full: true },
        {
          name: 'term_card_type',
          label: 'Card Type / Ownership',
          type: 'checks',
          full: true,
          options: [
            { name: 'Check Box 9', label: 'Visa' },
            { name: 'Check Box 20', label: 'MasterCard' },
            { name: 'Check Box 10', label: 'Discover' },
            { name: 'Check Box 17', label: 'Personal Credit Card' },
            { name: 'Check Box 19', label: 'Corporate Credit Card' }
          ]
        },
        { name: 'Text216', label: 'Initial — This order only' },
        { name: 'Text215', label: 'Initial — This and future orders' },
        { name: 'Text202', label: 'Shipping Address', full: true },
        { name: 'Text203', label: 'Ship City' },
        { name: 'Text204', label: 'Ship State' },
        { name: 'Text205', label: 'Ship Zip' },
        { name: 'Text206', label: 'Billing Address', full: true },
        { name: 'Text207', label: 'Bill City' },
        { name: 'Text208', label: 'Bill State' },
        { name: 'Text209', label: 'Bill Zip' },
        { name: 'Text200', label: 'Telephone #' },
        { name: 'Text201', label: 'Customer P.O.' },
        {
          name: 'ship_via',
          label: 'Shipped Via',
          type: 'checks',
          full: true,
          options: [
            { name: 'Check Box 11', label: 'FedEx' },
            { name: 'Check Box 12', label: 'UPS' },
            { name: 'Check Box 13', label: 'Other' }
          ]
        },
        {
          name: 'ship_service',
          label: 'Service Level',
          type: 'checks',
          full: true,
          options: [
            { name: 'Check Box 15', label: 'Ground' },
            { name: 'Check Box 16', label: 'Next Day' },
            { name: 'Check Box 18', label: '2nd Day' }
          ]
        },
        { name: 'Text210', label: 'Invoice Total' },
        { name: 'Text211', label: 'Shipping & Handling' },
        { name: 'Text212', label: 'Total Amount' },
        { name: 'Text213', label: 'Fax #' },
        { name: 'Text214', label: 'Assigned Credit Limit' },
        { name: 'Text218', label: 'Signature Date', type: 'date' }
      ]
    },
    {
      id: 'review',
      title: 'Review & Submit',
      description:
        'Confirm your information, then submit. Your answers will be filled into the official PDF and emailed to Anzo USA.',
      review: true
    }
  ];

  var DOCUMENT_UPLOADS = [
    { key: 'dl_front', label: "Driver's License (Front)", required: true },
    { key: 'dl_back', label: "Driver's License (Back)", required: true },
    { key: 'cc_front', label: 'Credit Card (Front)', required: true },
    { key: 'cc_back', label: 'Credit Card (Back)', required: true }
  ];

  var EXTRA_UPLOADS = [
    {
      key: 'reseller_permit',
      label: 'State Reseller Permit',
      required: true,
      accept: 'image/jpeg,image/png,image/webp,image/gif,application/pdf'
    }
  ];

  var REQUIRED_UPLOAD_KEYS = DOCUMENT_UPLOADS.concat(EXTRA_UPLOADS)
    .filter(function (doc) {
      return doc.required;
    })
    .map(function (doc) {
      return doc.key;
    });

  var ALLOWED_FILE_TYPES = {
    'image/jpeg': true,
    'image/png': true,
    'image/webp': true,
    'image/gif': true,
    'application/pdf': true
  };

  var MAX_IMAGE_BYTES = 10 * 1024 * 1024;

  var FIELD_LABELS = {};
  STEPS.forEach(function (step) {
    collectStepFields(step).forEach(function (field) {
      if (field.type === 'static' || field.type === 'file') return;
      if (field.options) {
        field.options.forEach(function (opt) {
          if (opt.name) FIELD_LABELS[opt.name] = opt.label;
        });
      } else if (field.name) {
        FIELD_LABELS[field.name] = field.label;
      }
    });
  });

  function collectStepFields(step) {
    if (step.fields) return step.fields;
    var all = [];
    (step.groups || []).forEach(function (group) {
      all = all.concat(group.fields || []);
    });
    return all;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fieldHtml(field, sid) {
    var id = 'Reseller-' + field.name.replace(/\s+/g, '_') + '-' + sid;
    var req = field.required
      ? ' <span class="reseller-application__required">*</span>'
      : '';
    var full = field.full ? ' reseller-application__field--full' : '';
    var type = field.type || 'text';

    if (type === 'radio') {
      var radios = field.options
        .map(function (opt, index) {
          return (
            '<label class="reseller-application__check">' +
            '<input type="radio" name="' +
            escapeHtml(field.name) +
            '" value="' +
            escapeHtml(opt.value) +
            '" data-reseller-field="' +
            escapeHtml(field.name) +
            '">' +
            '<span>' +
            escapeHtml(opt.label) +
            '</span></label>'
          );
        })
        .join('');
      return (
        '<div class="reseller-application__field' +
        full +
        '"><label>' +
        escapeHtml(field.label) +
        req +
        '</label><div class="reseller-application__checks">' +
        radios +
        '</div></div>'
      );
    }

    if (type === 'checks') {
      var checks = field.options
        .map(function (opt) {
          return (
            '<label class="reseller-application__check">' +
            '<input type="checkbox" name="' +
            escapeHtml(opt.name) +
            '" value="Yes" data-reseller-field="' +
            escapeHtml(opt.name) +
            '">' +
            '<span>' +
            escapeHtml(opt.label) +
            '</span></label>'
          );
        })
        .join('');
      return (
        '<div class="reseller-application__field' +
        full +
        '"><label>' +
        escapeHtml(field.label) +
        req +
        '</label><div class="reseller-application__checks">' +
        checks +
        '</div></div>'
      );
    }

    if (type === 'static') {
      return (
        '<div class="reseller-application__field' +
        full +
        '"><p class="reseller-application__field-note">' +
        escapeHtml(field.text || '') +
        '</p></div>'
      );
    }

    if (type === 'file') {
      var accept = field.accept || 'image/jpeg,image/png,image/webp,image/gif,application/pdf';
      var fileKey = field.key || field.name;
      return (
        '<div class="reseller-application__field' +
        full +
        ' reseller-application__field--upload"><label for="' +
        id +
        '">' +
        escapeHtml(field.label) +
        req +
        '</label><input type="file" id="' +
        id +
        '" name="' +
        escapeHtml(field.name) +
        '" accept="' +
        escapeHtml(accept) +
        '" class="reseller-application__file-input" data-reseller-doc-input data-doc-key="' +
        escapeHtml(fileKey) +
        '" data-doc-label="' +
        escapeHtml(field.label) +
        '"' +
        (field.required ? ' required' : '') +
        '><p class="reseller-application__uploads-note" data-reseller-file-name></p></div>'
      );
    }

    if (type === 'textarea') {
      return (
        '<div class="reseller-application__field' +
        full +
        '"><label for="' +
        id +
        '">' +
        escapeHtml(field.label) +
        req +
        '</label><textarea id="' +
        id +
        '" name="' +
        escapeHtml(field.name) +
        '" data-reseller-field="' +
        escapeHtml(field.name) +
        '" rows="3"></textarea></div>'
      );
    }

    return (
      '<div class="reseller-application__field' +
      full +
      '"><label for="' +
      id +
      '">' +
      escapeHtml(field.label) +
      req +
      '</label><input type="' +
      escapeHtml(type) +
      '" id="' +
      id +
      '" name="' +
      escapeHtml(field.name) +
      '" data-reseller-field="' +
      escapeHtml(field.name) +
      '"' +
      (field.required ? ' required' : '') +
      '>' +
      (field.note
        ? '<p class="reseller-application__field-note">' + escapeHtml(field.note) + '</p>'
        : '') +
      '</div>'
    );
  }

  function renderSteps(root) {
    var mount = root.querySelector('[data-reseller-steps]');
    var progress = root.querySelector('[data-reseller-progress]');
    if (!mount || !progress) return;

    progress.innerHTML = STEPS.map(function (step, index) {
      return (
        '<button type="button" class="reseller-application__progress-step" data-reseller-goto="' +
        index +
        '">' +
        (index + 1) +
        '. ' +
        escapeHtml(step.title) +
        '</button>'
      );
    }).join('');

    mount.innerHTML = STEPS.map(function (step, index) {
      var body = '';
      if (step.review) {
        body = '<pre class="reseller-application__review" data-reseller-review></pre>';
      } else if (step.groups) {
        body = step.groups
          .map(function (group) {
            return (
              '<div class="reseller-application__group"><div class="reseller-application__group-title">' +
              escapeHtml(group.title) +
              '</div>' +
              (group.note
                ? '<p class="reseller-application__group-note">' + escapeHtml(group.note) + '</p>'
                : '') +
              '<div class="reseller-application__grid reseller-application__grid--2">' +
              group.fields.map(function (f) {
                return fieldHtml(f, root.dataset.sectionId || 'main');
              }).join('') +
              '</div></div>'
            );
          })
          .join('');
      } else {
        body =
          '<div class="reseller-application__grid reseller-application__grid--2">' +
          step.fields
            .map(function (f) {
              return fieldHtml(f, root.dataset.sectionId || 'main');
            })
            .join('') +
          '</div>';
      }

      return (
        '<section class="reseller-application__step" data-reseller-step="' +
        index +
        '" ' +
        (index === 0 ? '' : 'hidden') +
        '>' +
        '<h2 class="reseller-application__step-title">' +
        escapeHtml(step.title) +
        '</h2>' +
        '<p class="reseller-application__step-desc">' +
        escapeHtml(step.description) +
        '</p>' +
        body +
        '</section>'
      );
    }).join('');

    var uploadsMount = root.querySelector('[data-reseller-uploads]');
    if (uploadsMount) {
      uploadsMount.innerHTML = buildDocumentUploadsHtml(root.dataset.sectionId || 'main');
      // Shown on company information (first step).
      uploadsMount.hidden = false;
    }

    bindDocumentUploads(root);
  }

  function buildDocumentUploadsHtml(sid) {
    var cards = DOCUMENT_UPLOADS.map(function (doc) {
      var id = 'Reseller-doc-' + doc.key + '-' + sid;
      return (
        '<div class="reseller-application__photo-upload" data-reseller-doc="' +
        escapeHtml(doc.key) +
        '">' +
        '<p class="reseller-application__photo-heading">' +
        escapeHtml(doc.label) +
        ' <span class="reseller-application__required">*</span></p>' +
        '<div class="reseller-application__photo-wrap">' +
        '<input type="file" accept="image/jpeg,image/png,image/webp,image/gif" class="reseller-application__photo-input" id="' +
        id +
        '" data-reseller-doc-input data-doc-key="' +
        escapeHtml(doc.key) +
        '" data-doc-label="' +
        escapeHtml(doc.label) +
        '" required>' +
        '<label for="' +
        id +
        '" class="reseller-application__photo-box" data-reseller-doc-box>' +
        '<span class="reseller-application__photo-plus" aria-hidden="true">+</span>' +
        '<span class="reseller-application__photo-label">Add Image</span>' +
        '<img class="reseller-application__photo-preview" data-reseller-doc-preview alt="">' +
        '</label></div></div>'
      );
    }).join('');

    return (
      '<h3 class="reseller-application__uploads-title">Identity &amp; Card Images</h3>' +
      '<p class="reseller-application__uploads-note">Required. Upload clear photos of the front and back of your driver\'s license and credit card to keep on file. JPG, PNG, WEBP, or GIF up to 10 MB each.</p>' +
      '<div class="reseller-application__photos">' +
      cards +
      '</div>'
    );
  }

  function bindDocumentUploads(root) {
    root.querySelectorAll('[data-reseller-doc]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-reseller-doc-input]');
      var box = wrap.querySelector('[data-reseller-doc-box]');
      var preview = wrap.querySelector('[data-reseller-doc-preview]');
      if (!input || !box || !preview) return;

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (preview.dataset.objectUrl) {
          try {
            URL.revokeObjectURL(preview.dataset.objectUrl);
          } catch (e) {}
          delete preview.dataset.objectUrl;
        }

        if (!file) {
          box.classList.remove('has-image');
          preview.removeAttribute('src');
          preview.alt = '';
          return;
        }

        if (!ALLOWED_FILE_TYPES[file.type] || file.type === 'application/pdf') {
          showError(root, 'Please upload JPG, PNG, WEBP, or GIF images only.');
          input.value = '';
          box.classList.remove('has-image');
          preview.removeAttribute('src');
          return;
        }

        if (file.size > MAX_IMAGE_BYTES) {
          showError(root, 'Each image must be 10 MB or smaller.');
          input.value = '';
          box.classList.remove('has-image');
          preview.removeAttribute('src');
          return;
        }

        hideError(root);
        var url = URL.createObjectURL(file);
        preview.dataset.objectUrl = url;
        preview.src = url;
        preview.alt = file.name;
        box.classList.add('has-image');
      });
    });

    root.querySelectorAll('.reseller-application__file-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        var nameEl = input.parentNode.querySelector('[data-reseller-file-name]');
        if (!file) {
          if (nameEl) nameEl.textContent = '';
          return;
        }
        if (!ALLOWED_FILE_TYPES[file.type]) {
          showError(root, 'Please upload a JPG, PNG, WEBP, GIF, or PDF file.');
          input.value = '';
          if (nameEl) nameEl.textContent = '';
          return;
        }
        if (file.size > MAX_IMAGE_BYTES) {
          showError(root, 'Each file must be 10 MB or smaller.');
          input.value = '';
          if (nameEl) nameEl.textContent = '';
          return;
        }
        hideError(root);
        if (nameEl) nameEl.textContent = 'Selected: ' + file.name;
      });
    });
  }

  function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var result = String(reader.result || '');
        var comma = result.indexOf(',');
        resolve(comma >= 0 ? result.slice(comma + 1) : result);
      };
      reader.onerror = function () {
        reject(new Error('Unable to read ' + file.name));
      };
      reader.readAsDataURL(file);
    });
  }

  function validateDocumentUploads(form) {
    var missing = [];
    var required = DOCUMENT_UPLOADS.concat(EXTRA_UPLOADS).filter(function (doc) {
      return doc.required;
    });

    required.forEach(function (doc) {
      var input = form.querySelector(
        '[data-reseller-doc-input][data-doc-key="' + doc.key + '"]'
      );
      if (!input || !input.files || !input.files[0]) {
        missing.push(doc.label);
      }
    });

    if (missing.length) {
      return 'Please upload all required files: ' + missing.join(', ') + '.';
    }
    return null;
  }

  function guaranteeStepIndex() {
    for (var i = 0; i < STEPS.length; i++) {
      if (STEPS[i].id === 'guarantee') return i;
    }
    return 0;
  }

  async function collectDocumentUploads(form) {
    var documents = [];
    var skipped = [];
    var inputs = form.querySelectorAll('[data-reseller-doc-input]');

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var key = input.getAttribute('data-doc-key');
      var label = input.getAttribute('data-doc-label') || key;
      if (!input.files || !input.files[0]) continue;

      var file = input.files[0];
      if (!ALLOWED_FILE_TYPES[file.type]) {
        skipped.push(label + ' skipped: unsupported file type.');
        continue;
      }
      if (file.size > MAX_IMAGE_BYTES) {
        skipped.push(label + ' skipped: exceeds the 10 MB size limit.');
        continue;
      }

      documents.push({
        key: key,
        label: label,
        original_name: file.name,
        mime_type: file.type,
        data_base64: await fileToBase64(file)
      });
    }

    return { documents: documents, skipped: skipped };
  }

  function collectFormData(form) {
    var data = {};

    form.querySelectorAll('[data-reseller-field]').forEach(function (el) {
      var name = el.getAttribute('data-reseller-field');
      if (!name) return;

      if (el.type === 'checkbox') {
        if (el.checked) data[name] = true;
        return;
      }

      if (el.type === 'radio') {
        if (el.checked) data[name] = el.value;
        return;
      }

      var value = el.value;
      if (value && String(value).trim() !== '') {
        data[name] = String(value).trim();
      }
    });

    return data;
  }

  function getEntityMarkField(entityType) {
    var companyStep = STEPS[0];
    var entityField = (companyStep.fields || []).find(function (field) {
      return field.name === 'entity_type';
    });
    if (!entityField || !entityField.options) return null;
    var match = entityField.options.find(function (opt) {
      return opt.value === entityType;
    });
    return match && match.markField ? match.markField : null;
  }

  function applyFormData(form, data) {
    if (!data) return;
    form.querySelectorAll('[data-reseller-field]').forEach(function (el) {
      var name = el.getAttribute('data-reseller-field');
      if (!name) return;

      if (el.type === 'checkbox') {
        el.checked = !!data[name];
        return;
      }

      if (el.type === 'radio') {
        el.checked = data[name] === el.value;
        return;
      }

      if (typeof data[name] === 'string') {
        el.value = data[name];
      }
    });
  }

  function saveDraft(form, stepIndex) {
    try {
      var data = collectFormData(form);
      localStorage.setItem(DRAFT_KEY, JSON.stringify(data));
      localStorage.setItem(
        DRAFT_META_KEY,
        JSON.stringify({ step: stepIndex, savedAt: new Date().toISOString() })
      );
    } catch (e) {}
  }

  function loadDraft() {
    try {
      var raw = localStorage.getItem(DRAFT_KEY);
      var metaRaw = localStorage.getItem(DRAFT_META_KEY);
      return {
        data: raw ? JSON.parse(raw) : null,
        meta: metaRaw ? JSON.parse(metaRaw) : null
      };
    } catch (e) {
      return { data: null, meta: null };
    }
  }

  function clearDraft() {
    try {
      localStorage.removeItem(DRAFT_KEY);
      localStorage.removeItem(DRAFT_META_KEY);
    } catch (e) {}
  }

  function clearDocumentUploads(root) {
    root.querySelectorAll('[data-reseller-doc]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-reseller-doc-input]');
      var box = wrap.querySelector('[data-reseller-doc-box]');
      var preview = wrap.querySelector('[data-reseller-doc-preview]');
      if (input) input.value = '';
      if (preview) {
        if (preview.dataset.objectUrl) {
          try {
            URL.revokeObjectURL(preview.dataset.objectUrl);
          } catch (e) {}
          delete preview.dataset.objectUrl;
        }
        preview.removeAttribute('src');
        preview.alt = '';
      }
      if (box) box.classList.remove('has-image');
    });
  }

  function resetFormSession(root, form) {
    clearDraft();
    form.reset();
    form.querySelectorAll('[data-reseller-field]').forEach(function (el) {
      if (el.type === 'checkbox' || el.type === 'radio') {
        el.checked = false;
      } else {
        el.value = '';
      }
    });
    clearDocumentUploads(root);
    var draftNote = root.querySelector('[data-reseller-draft-note]');
    if (draftNote) {
      draftNote.hidden = true;
      draftNote.textContent = '';
    }
    hideError(root);
  }

  function buildSummary(data) {
    var lines = [];
    Object.keys(FIELD_LABELS).forEach(function (name) {
      if (data[name] === true) {
        lines.push(FIELD_LABELS[name] + ': Yes');
      } else if (data[name]) {
        lines.push(FIELD_LABELS[name] + ': ' + data[name]);
      }
    });
    if (data.entity_type) {
      lines.push('Entity Type: ' + data.entity_type);
    }
    return lines.join('\n');
  }

  function validateStep(step, data) {
    var fields = collectStepFields(step);
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (!field.required) continue;
      if (field.type === 'checks' || field.type === 'static' || field.type === 'file') continue;
      if (!data[field.name]) {
        return 'Please complete: ' + field.label;
      }
    }
    return null;
  }

  function formatDateForPdf(value) {
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    var parts = value.split('-');
    return parts[1] + '/' + parts[2] + '/' + parts[0];
  }

  var DEFAULT_PDF_JSON_URL = 'https://support.anzousa.com/reseller-api/blank-pdf-json.php';
  var DEFAULT_PDF_BINARY_URL = 'https://support.anzousa.com/reseller-api/blank-pdf.php';

  function bytesStartWithPdf(bytes) {
    return bytes && bytes.length >= 4 && bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46;
  }

  function bytesLookLikeBase64Pdf(bytes) {
    // "JVBE" is base64 for "%PDF"
    return bytes && bytes.length >= 4 && bytes[0] === 0x4a && bytes[1] === 0x56 && bytes[2] === 0x42 && bytes[3] === 0x45;
  }

  function uint8ToBinaryString(bytes) {
    var binary = '';
    var chunkSize = 8192;
    for (var i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
    }
    return binary;
  }

  function decodeBase64ToUint8(b64) {
    var binary = atob(String(b64 || '').replace(/\s/g, ''));
    var out = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i += 1) {
      out[i] = binary.charCodeAt(i);
    }
    return out;
  }

  function normalizePdfBytes(buffer) {
    var bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    if (bytesStartWithPdf(bytes)) {
      return bytes;
    }
    // Some hosts/CDNs return the PDF body as base64 text instead of binary.
    if (bytesLookLikeBase64Pdf(bytes)) {
      var decoded = decodeBase64ToUint8(uint8ToBinaryString(bytes));
      if (bytesStartWithPdf(decoded)) {
        return decoded;
      }
    }
    throw new Error(
      'The PDF URL did not return a valid PDF. Set the blank PDF URL to ' + DEFAULT_PDF_JSON_URL
    );
  }

  async function fetchBlankPdfBytes(pdfUrl) {
    var candidates = [];
    var configured = (pdfUrl || '').trim();

    // Prefer the JSON endpoint — avoids binary/CORS/proxy corruption.
    if (configured.indexOf('blank-pdf-json.php') !== -1) {
      candidates.push(configured);
    } else {
      candidates.push(DEFAULT_PDF_JSON_URL);
    }

    if (configured && configured.indexOf('blank-pdf-json.php') === -1) {
      candidates.push(configured);
    }
    candidates.push(DEFAULT_PDF_BINARY_URL);

    var lastError = null;
    for (var i = 0; i < candidates.length; i += 1) {
      var url = candidates[i];
      try {
        var response = await fetch(url, { credentials: 'omit', cache: 'no-cache' });
        if (!response.ok) {
          throw new Error('HTTP ' + response.status + ' for ' + url);
        }

        var contentType = (response.headers.get('content-type') || '').toLowerCase();
        if (url.indexOf('blank-pdf-json.php') !== -1 || contentType.indexOf('application/json') !== -1) {
          var payload = await response.json();
          if (!payload || !payload.pdf_base64) {
            throw new Error('JSON PDF payload missing pdf_base64');
          }
          var fromJson = decodeBase64ToUint8(payload.pdf_base64);
          if (!bytesStartWithPdf(fromJson)) {
            throw new Error('Decoded JSON PDF was invalid');
          }
          return fromJson;
        }

        return normalizePdfBytes(await response.arrayBuffer());
      } catch (err) {
        lastError = err;
      }
    }

    throw new Error(
      (lastError && lastError.message) ||
        'Unable to load the reseller application PDF. Deploy blank-pdf-json.php on support.anzousa.com.'
    );
  }

  async function fillPdf(pdfUrl, data) {
    if (typeof PDFLib === 'undefined') {
      throw new Error('PDF library failed to load. Please refresh and try again.');
    }

    var pdfBytes = await fetchBlankPdfBytes(pdfUrl);
    var pdfDoc = await PDFLib.PDFDocument.load(pdfBytes, { ignoreEncryption: true });
    var form = pdfDoc.getForm();
    var skipKeys = {
      entity_type: true,
      business_type: true,
      prepaid_card_type: true,
      term_card_type: true,
      ship_via: true,
      ship_service: true,
      products_purchased_note: true,
      reseller_permit: true,
      tax_cert_statement: true
    };
    // Entity marker fields are set explicitly below.
    var entityMarkers = { Text10: true, Text11: true, Text12: true, Text13: true, Text14: true };

    Object.keys(data).forEach(function (name) {
      if (skipKeys[name] || entityMarkers[name]) return;

      if (data[name] === true) {
        try {
          form.getCheckBox(name).check();
        } catch (e) {}
        return;
      }

      if (!data[name] || typeof data[name] !== 'string') return;

      try {
        form.getTextField(name).setText(formatDateForPdf(data[name]));
      } catch (e) {}
    });

    // Mark entity type with an X (Other uses specify text when provided).
    ['Text10', 'Text11', 'Text12', 'Text13', 'Text14'].forEach(function (name) {
      try {
        form.getTextField(name).setText('');
      } catch (e) {}
    });
    if (data.entity_type) {
      var markField = getEntityMarkField(data.entity_type);
      if (markField) {
        var markValue = 'X';
        if (data.entity_type === 'other' && data.Text14) {
          markValue = formatDateForPdf(data.Text14);
        }
        try {
          form.getTextField(markField).setText(markValue);
        } catch (e) {}
      }
    }

    var font = await pdfDoc.embedFont(PDFLib.StandardFonts.Helvetica);
    form.updateFieldAppearances(font);

    // Capture underline geometry before flatten removes widgets.
    var underlineTargets = collectTextFieldUnderlines(pdfDoc, form);

    // Flatten so values are visible in email clients / Preview / Chrome
    // (AcroForm values alone often render blank without this).
    try {
      form.flatten();
    } catch (e) {}

    // Flatten paints opaque field appearances that cover the template underlines.
    redrawTextFieldUnderlines(pdfDoc, underlineTargets);

    return pdfDoc.save();
  }

  function collectTextFieldUnderlines(pdfDoc, form) {
    var pages = pdfDoc.getPages();
    var targets = [];

    form.getFields().forEach(function (field) {
      if (field.constructor.name !== 'PDFTextField') return;

      try {
        field.acroField.getWidgets().forEach(function (widget) {
          var rect = widget.getRectangle();
          if (!rect || rect.width < 8 || rect.height < 4) return;

          var pageIndex = -1;
          try {
            var pageRef = widget.P();
            if (pageRef) {
              pageIndex = pages.findIndex(function (page) {
                return page.ref === pageRef;
              });
            }
          } catch (e) {}

          if (pageIndex < 0) {
            var cx = rect.x + rect.width / 2;
            var cy = rect.y + rect.height / 2;
            pageIndex = pages.findIndex(function (page) {
              var size = page.getSize();
              return cx >= 0 && cx <= size.width && cy >= 0 && cy <= size.height;
            });
          }

          if (pageIndex < 0) return;

          targets.push({
            pageIndex: pageIndex,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
          });
        });
      } catch (e) {}
    });

    return targets;
  }

  function redrawTextFieldUnderlines(pdfDoc, targets) {
    if (!targets || !targets.length || !PDFLib.rgb) return;
    var pages = pdfDoc.getPages();
    var black = PDFLib.rgb(0, 0, 0);

    targets.forEach(function (t) {
      var page = pages[t.pageIndex];
      if (!page) return;

      // Draw on top of flattened field appearances so underlines stay visible.
      page.drawLine({
        start: { x: t.x, y: t.y + 0.75 },
        end: { x: t.x + t.width, y: t.y + 0.75 },
        thickness: 0.9,
        color: black
      });
    });
  }

  function arrayBufferToBase64(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = '';
    var chunkSize = 8192;
    for (var i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
  }

  function sanitizeFileName(name) {
    return (name || 'reseller-application')
      .replace(/[^a-z0-9-_]+/gi, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase()
      .slice(0, 60);
  }

  function downloadPdf(pdfBytes, fileName) {
    var blob = new Blob([pdfBytes], { type: 'application/pdf' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = fileName + '.pdf';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }

  async function submitApplication(endpointUrl, secret, payload) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = null;
    if (controller) {
      timeoutId = setTimeout(function () {
        controller.abort();
      }, 600000);
    }

    var response;
    try {
      response = await fetch(endpointUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Reseller-Secret': secret
        },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined
      });
    } catch (err) {
      if (err && err.name === 'AbortError') {
        throw new Error('Submission timed out. Large images can take several minutes — please try again or use smaller files.');
      }
      throw err;
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }

    var result = await response.json().catch(function () {
      return {};
    });
    if (!response.ok || !result.success) {
      throw new Error(result.message || 'Unable to submit your application. Please try again.');
    }
  }

  function showError(root, message) {
    var errorEl = root.querySelector('[data-reseller-error]');
    if (!errorEl) return;
    errorEl.hidden = false;
    errorEl.textContent = message;
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function hideError(root) {
    var errorEl = root.querySelector('[data-reseller-error]');
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function setProcessing(root, isProcessing) {
    var overlay = root.querySelector('[data-reseller-overlay]');
    var submitButton = root.querySelector('[data-reseller-submit]');
    if (overlay) {
      overlay.hidden = !isProcessing;
      overlay.setAttribute('aria-hidden', isProcessing ? 'false' : 'true');
    }
    document.body.classList.toggle('reseller-application--processing', isProcessing);
    if (submitButton) {
      submitButton.disabled = isProcessing;
      submitButton.textContent = isProcessing
        ? submitButton.dataset.loadingText || 'Submitting...'
        : submitButton.dataset.defaultText || 'Submit Application';
    }
  }

  function showSuccess(root) {
    var successEl = root.querySelector('[data-reseller-success]');
    var formWrap = root.querySelector('[data-reseller-form-wrap]');
    if (formWrap) formWrap.hidden = true;
    if (successEl) {
      successEl.hidden = false;
      successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function initSection(root) {
    var form = root.querySelector('[data-reseller-form]');
    if (!form) return;

    renderSteps(root);

    var currentStep = 0;
    var draft = loadDraft();
    if (draft.data) applyFormData(form, draft.data);
    if (draft.meta && typeof draft.meta.step === 'number') {
      currentStep = Math.min(Math.max(draft.meta.step, 0), STEPS.length - 1);
    }

    var draftNote = root.querySelector('[data-reseller-draft-note]');
    if (draftNote && draft.meta && draft.meta.savedAt) {
      draftNote.hidden = false;
      draftNote.textContent =
        'Draft restored from ' +
        new Date(draft.meta.savedAt).toLocaleString() +
        '. Your progress is saved automatically in this browser.';
    }

    function updateReview() {
      var review = root.querySelector('[data-reseller-review]');
      if (!review) return;
      review.textContent = buildSummary(collectFormData(form)) || 'No information entered yet.';
    }

    function showStep(index) {
      currentStep = index;
      root.querySelectorAll('[data-reseller-step]').forEach(function (el) {
        el.hidden = Number(el.getAttribute('data-reseller-step')) !== index;
      });
      root.querySelectorAll('[data-reseller-goto]').forEach(function (btn) {
        var i = Number(btn.getAttribute('data-reseller-goto'));
        btn.classList.toggle('is-active', i === index);
        btn.classList.toggle('is-complete', i < index);
      });

      var nextBtn = root.querySelector('[data-reseller-next]');
      var submitBtn = root.querySelector('[data-reseller-submit]');
      var earlyNote = root.querySelector('[data-reseller-early-submit-note]');
      var uploadsPanel = root.querySelector('[data-reseller-uploads]');
      var isLastStep = index === STEPS.length - 1;
      var canSubmit = index >= 1;
      var isFirstStep = index === 0;

      if (nextBtn) nextBtn.hidden = isLastStep;
      if (submitBtn) submitBtn.hidden = !canSubmit;
      if (earlyNote) earlyNote.hidden = !canSubmit || isLastStep;
      // Required ID / card images live on Company Information (step 1).
      if (uploadsPanel) uploadsPanel.hidden = !isFirstStep;

      if (STEPS[index].review) updateReview();
      saveDraft(form, currentStep);
      hideError(root);
      root.querySelector('[data-reseller-form-wrap]').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    form.addEventListener('input', function () {
      saveDraft(form, currentStep);
      if (STEPS[currentStep].review) updateReview();
    });
    form.addEventListener('change', function () {
      saveDraft(form, currentStep);
      if (STEPS[currentStep].review) updateReview();
    });

    root.querySelectorAll('[data-reseller-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(Number(btn.getAttribute('data-reseller-goto')));
      });
    });

    var nextBtn = root.querySelector('[data-reseller-next]');
    var resetBtn = root.querySelector('[data-reseller-reset]');

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        var confirmed = window.confirm(
          'Reset this application? This clears your saved progress and uploaded images in this browser.'
        );
        if (!confirmed) return;
        resetFormSession(root, form);
        showStep(0);
        root.querySelector('[data-reseller-form-wrap]').scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var data = collectFormData(form);
        var error = validateStep(STEPS[currentStep], data);
        if (error) {
          showError(root, error);
          return;
        }
        if (currentStep === 0) {
          var idUploadError = validateDocumentUploads(form);
          if (idUploadError && idUploadError.indexOf('State Reseller Permit') === -1) {
            // Still require ID/card images on step 1; permit is on a later step.
          }
          var missingId = [];
          DOCUMENT_UPLOADS.forEach(function (doc) {
            var input = form.querySelector(
              '[data-reseller-doc-input][data-doc-key="' + doc.key + '"]'
            );
            if (!input || !input.files || !input.files[0]) missingId.push(doc.label);
          });
          if (missingId.length) {
            showError(root, 'Please upload all required images: ' + missingId.join(', ') + '.');
            var uploadsPanel = root.querySelector('[data-reseller-uploads]');
            if (uploadsPanel) {
              uploadsPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
          }
        }
        if (STEPS[currentStep].id === 'guarantee') {
          var permitInput = form.querySelector(
            '[data-reseller-doc-input][data-doc-key="reseller_permit"]'
          );
          if (!permitInput || !permitInput.files || !permitInput.files[0]) {
            showError(root, 'Please attach a copy of your State Reseller Permit.');
            if (permitInput) {
              permitInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
          }
        }
        if (currentStep < STEPS.length - 1) showStep(currentStep + 1);
      });
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      hideError(root);

      var data = collectFormData(form);
      var company = data.Text1 || '';
      var contactName = data.Text26 || data.Text90 || data.Text24 || '';
      var email = data.Text25 || data.Text34 || '';
      var phone = data.Text8 || data.Text28 || '';

      var companyStepError = validateStep(STEPS[0], data);
      if (companyStepError) {
        showError(root, companyStepError);
        showStep(0);
        return;
      }

      if (!company || !email) {
        showError(
          root,
          'Please complete Company Name and Purchaser Email on the Company Information step before submitting.'
        );
        showStep(0);
        return;
      }

      var uploadError = validateDocumentUploads(form);
      if (uploadError) {
        showError(root, uploadError);
        if (uploadError.indexOf('State Reseller Permit') !== -1) {
          showStep(guaranteeStepIndex());
        } else {
          showStep(0);
          var uploadsPanel = root.querySelector('[data-reseller-uploads]');
          if (uploadsPanel) {
            setTimeout(function () {
              uploadsPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 50);
          }
        }
        return;
      }

      if (!contactName) {
        contactName = data.Text24 || company;
      }

      var pdfUrl = root.dataset.pdfUrl;
      var submitEndpoint = root.dataset.submitEndpoint;
      var submitSecret = root.dataset.submitSecret;

      if (!submitEndpoint || !submitSecret) {
        showError(root, 'Reseller submission is not configured. Please contact support.');
        return;
      }

      setProcessing(root, true);

      try {
        var pdfBytes = await fillPdf(pdfUrl, data);
        var fileName = 'anzo-reseller-application-' + sanitizeFileName(company || contactName);
        var uploadResult = await collectDocumentUploads(form);
        if (uploadResult.skipped.length > 0) {
          showError(
            root,
            'Some required files could not be used:\n' + uploadResult.skipped.join('\n')
          );
          showStep(0);
          return;
        }
        var requiredKeys = REQUIRED_UPLOAD_KEYS.slice();
        var uploadedKeys = uploadResult.documents.map(function (doc) {
          return doc.key;
        });
        var missingKeys = requiredKeys.filter(function (key) {
          return uploadedKeys.indexOf(key) === -1;
        });
        if (missingKeys.length) {
          showError(root, 'Please upload all required identity, credit card, and reseller permit files.');
          showStep(missingKeys.indexOf('reseller_permit') !== -1 ? guaranteeStepIndex() : 0);
          return;
        }
        await submitApplication(submitEndpoint, submitSecret, {
          secret: submitSecret,
          customer_name: contactName,
          company_name: company,
          email: email,
          phone: phone,
          summary: buildSummary(data),
          pdf_base64: arrayBufferToBase64(pdfBytes),
          id_documents: uploadResult.documents
        });
        downloadPdf(pdfBytes, fileName);
        clearDraft();
        showSuccess(root);
      } catch (error) {
        showError(root, error.message || 'Something went wrong. Please try again.');
      } finally {
        setProcessing(root, false);
      }
    });

    showStep(currentStep);
  }

  function init() {
    document.querySelectorAll('[data-reseller-application]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-reseller-application]');
    if (root) initSection(root);
  });
})();
